module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    on: {
      "enter": _vm.pageFadeIn,
      "leave": _vm.pageFadeOut
    }
  }, [_c('keep-alive', [_c('Object3D', {
    ref: "page-content"
  }, [_c('Woody', {
    ref: "woody",
    attrs: {
      "position": {
        x: 0,
        y: 0,
        z: 0.0
      }
    },
    on: {
      "api": function (v) {
        _vm.execStack.woody = v.render; /*mouseStack.woody = v.setMouse*/
      }
    }
  }), _vm._v(" "), _c('router-view', {
    ref: "sub-page-content",
    tag: "component",
    attrs: {
      "aspect": _vm.aspect,
      "camera": _vm.camera
    },
    on: {
      "setMouse": function (v) {
        _vm.mouseStack.currentSubPage = v
      },
      "exec": function (v) {
        _vm.execStack.currentSubPage = v
      },
      "punched": _vm.tweenWoody
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-950b3302","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NikeWebGL/Pages/Play/Play.vue
// module id = 610
// module chunks = 0